import React, { useContext } from "react";
import { ShopContext } from "../../context/shop-context";
import { PlusCircle , MinusCircle } from "phosphor-react";

export const CartItem = (props) => {
  const { id, productName, price, productImage } = props.data;
  const { cartItems, addToCart, removeFromCart, updateCartItemCount } =
    useContext(ShopContext);

  return (
    <div className="cartItem">
      <img src={productImage} />
      <div className="description">
        <p>
          <b>{productName}</b>
        </p>
        <p> Price: ${price}</p>
        <div className="countHandler">
          <button className="svgBtn" onClick={() => removeFromCart(id)}> <MinusCircle/> </button>
          <input
            value={cartItems[id]}
            onChange={(e) => updateCartItemCount(Number(e.target.value), id)}
          />
          <button className="svgBtn" onClick={() => addToCart(id)}> <PlusCircle/> </button>
        </div>
      </div>
    </div>
  );
};
